"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgSmallLogo = function SvgSmallLogo(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.999 13.998c0 7.731-6.27 14-14 14S0 21.73 0 13.998c0-7.73 6.269-14 14-14 7.73 0 13.999 6.27 13.999 14Z",
    fill: "#3DACF6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 5.604c-4.136 0-7.482 3.36-7.482 7.496 0 .49.039.776.039.776a.78.78 0 0 0 .742.646h13.394a.78.78 0 0 0 .742-.646s.04-.293.04-.776a7.475 7.475 0 0 0-7.476-7.496Z",
    fill: "#FCEE21"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.677 16.48c0 .39-.352.717-.782.717H4.036c-.43 0-.781-.326-.781-.718 0-.391.351-.717.781-.717h19.86c.43 0 .78.326.78.717ZM21.747 19.219c0 .398-.352.717-.781.717h-14c-.43 0-.78-.32-.78-.717 0-.398.35-.718.78-.718h14c.43 0 .781.32.781.718ZM18.23 21.96c0 .397-.35.717-.78.717h-6.968c-.43 0-.781-.32-.781-.718 0-.398.351-.718.781-.718h6.967c.43 0 .782.32.782.718Z",
    fill: "#fff"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgSmallLogo);
var _default = exports["default"] = Memo;